import React, { useState } from "react";
import logo from "../assets/9.png";
import { Link } from "react-router-dom";

export default function Navbar() {
  const [navLinksVisible, setNavLinksVisible] = useState(false);



  const toggleNavLinks = () => {
    setNavLinksVisible(!navLinksVisible);
  };

  return (
    <>
      <header className=" postion-realative header2">
        <nav className="navbar">
          <div className="logo">
            <img src={logo} alt="KINGSLAND TRAVEL & TOURISM L.L.C" />
          </div>
          <ul className="nav-links">
            <li>
              {/* Replace anchor tags with Link components */}
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/about">About</Link>
            </li>
            <li>
              <Link to="/services">Services</Link>
            </li>
            <li>
              <Link to="/contact">Contact</Link>
            </li>
          </ul>
        </nav>
        {navLinksVisible && (
          <ul className="nav-links-mobile">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/about">About</Link>
            </li>
            <li>
              <Link to="/services">Services</Link>
            </li>
            <li>
              <Link to="/contact">Contact</Link>
            </li>
          </ul>
        )}
        <div className="hamburger" onClick={toggleNavLinks}>
          <div className="bar"></div>
          <div className="bar"></div>
          <div className="bar"></div>
        </div>
      </header>
    </>
  );
}
